import React from "react";
import calsses from "./ScoreSection.module.css";
import { useSelector } from "react-redux";
import QuestionCategoriesList from "./QuestionCatList";
import EditIcon from '@mui/icons-material/Edit';
import SettingsIcon from '@mui/icons-material/Settings';
import { Outlet, useNavigate, useParams } from "react-router-dom";

const ScoreSection = () => {

  const navigate = useNavigate();
  const { id, cid } = useParams(); 

  const marks = useSelector((state) => state.DashMarks);

  /* ----------- CATEGORY COLOR ----------- */

  const getColor = (id) => {
    switch (Number(id)) {
      case 5:
        return "#f6d331";
      case 6:
        return "#34b3ad";
      case 7:
        return "#ec3857";
      default:
        return "#ec3857";
    }
  };

  /* ----------- CATEGORY TITLE ----------- */

  const getTitle = (cid) => {
    switch (Number(cid)) {
      case 1:
        return "Achievements";
      case 2:
        return "Leadership";
      case 3:
        return "Individual contribution";
      case 8:
        return "Sport Skills";
      case 9:
        return "Performing Art Skills";
      case 10:
        return "Social Skills";
      case 11:
        return "Life Skills";
      case 4:
        return "Act of Kindness";
      case 5:
        return "Good Practices";
      case 13:
        return "Fitness";
      default:
        return "Talent Score";
    }
  };

  const Title = getTitle(cid);
  const Color = getColor(id);

  /* ----------- NAVIGATION ----------- */

  const handleDataChange = (catId, subCatId) => {
    navigate(`/talentscore/questionaire/${catId}/${subCatId}`);
  };

  return (
    <div className={calsses["main-section"]}>
      <div className="container">
        <div className={calsses["main-section-data"]}>

          {/* ----------- SCORE CARDS ----------- */}

          <div className={calsses["search-form"]}>

            {/* ALL TALENT SCORE */}

            <div className="col-xl-3 col-md-6 p-2">
              <div className="card">
                <div className="card-block">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-8">
                        <h4>{marks.AverageScore}</h4>
                        <h6>All talent score</h6>
                      </div>
                    </div>
                  </div>

                  <div
                    className={"card-footer bg-danger text-white"}
                  >
                   <div className="row align-items-center">
  <div className="col-9">
    <span>Talent Score</span>
  </div>
  <div className="col-3">
    <SettingsIcon />
  </div>
</div>
                  </div>

                </div>
              </div>
            </div>

            {/* ACHIEVEMENTS */}

            <div className="col-xl-3 col-md-6 p-2">
              <div className="card">
                <div className="card-block">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-8">
                        <h4>{marks.cat1}</h4>
                        <h6>Achievements</h6>
                      </div>
                    </div>
                  </div>

                  <div
                    className={`card-footer ${calsses["bg-yellow"]}`}
                    onClick={() => handleDataChange(5, 1)}
                  >
                    <div className="row align-items-center">
                      <div className="col-9">
                        <span>Edit</span>
                      </div>
                      <div className="col-3">
                        <EditIcon />
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>

            {/* DAILY HABITS */}

            <div className="col-xl-3 col-md-6 p-2">
              <div className="card">
                <div className="card-block">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-8">
                        <h4>{marks.cat2}</h4>
                        <h6>Daily Habits</h6>
                      </div>
                    </div>
                  </div>

                  <div
                    className={`card-footer ${calsses["bg-teal"]}`}
                    onClick={() => handleDataChange(6, 4)}
                  >
                    <div className="row align-items-center">
                      <div className="col-9">
                        <span>Edit</span>
                      </div>
                      <div className="col-3">
                        <EditIcon />
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>

            {/* FITNESS */}

            <div className="col-xl-3 col-md-6 p-2">
              <div className="card">
                <div className="card-block">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-8">
                        <h4>{marks.cat3}</h4>
                        <h6>Fitness</h6>
                      </div>
                    </div>
                  </div>

                  <div
                    className={`card-footer ${calsses["bg-red"]}`}
                    onClick={() => handleDataChange(7, 13)}
                  >
                    <div className="row align-items-center">
                      <div className="col-9">
                        <span>Edit</span>
                      </div>
                      <div className="col-3">
                        <EditIcon />
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>

          </div>

          {/* ----------- TITLE SECTION ----------- */}

          <div className="row">
            <div className="col-md-12 col-lg-12">
              <div className="main-ws-sec">
                <div
                  className="post-topbar"
                  style={{ borderTop: `4px solid ${Color}` }}
                >
                  <h2>{Title}</h2>
                </div>
              </div>
            </div>
          </div>

          {/* ----------- MAIN CONTENT ----------- */}

          <div className="row">

            {/* SIDEBAR */}

            <div className="col-lg-4 col-md-4">
              <div className="main-left-sidebar no-margin">
                <div className="user-data full-width">
                  <QuestionCategoriesList id={Number(id)} />
                </div>
              </div>
            </div>

            {/* QUESTION AREA */}

            <div className="col-lg-8 col-md-8 no-pd">
              <div className="main-ws-sec">
                <div
                  className="post-topbar"
                  style={{ borderTop: `4px solid ${Color}` }}
                >
                  <Outlet />
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>
    </div>
  );
};

export default ScoreSection;